import {
  EOrderEventActorType,
  EWarehouseOrderChangeField,
  EWarehouseOrderEventType,
  EWarehouseOrderPairingSource,
  EWarehouseOrderPairingState,
  EWarehouseOrderStatus,
  WAREHOUSE_ORDER_REPORT_CURRENCY_ISO_CODE,
} from '@mahawi/eshop-common/src/types';

import { EMPTY_VALUE } from '../../fragments/empty-value';

export const WAREHOUSE_ORDER_STATUS_LABEL: Record<
  EWarehouseOrderStatus,
  string
> = {
  [EWarehouseOrderStatus.OPEN]: 'Open',
  [EWarehouseOrderStatus.PARTIALLY_DELIVERED]: 'Partially delivered',
  [EWarehouseOrderStatus.DELIVERED]: 'Delivered',
  [EWarehouseOrderStatus.CANCELLED]: 'Cancelled',
};

export const WAREHOUSE_ORDER_STATUS_COLOR: Record<
  EWarehouseOrderStatus,
  string
> = {
  [EWarehouseOrderStatus.OPEN]: 'blue',
  [EWarehouseOrderStatus.PARTIALLY_DELIVERED]: 'orange',
  [EWarehouseOrderStatus.DELIVERED]: 'green',
  [EWarehouseOrderStatus.CANCELLED]: 'default',
};

export const WAREHOUSE_ORDER_PAIRING_STATE_LABEL: Record<
  EWarehouseOrderPairingState,
  string
> = {
  [EWarehouseOrderPairingState.PAIRED]: 'Paired',
  [EWarehouseOrderPairingState.SUGGESTED]: 'Needs review',
  [EWarehouseOrderPairingState.UNPAIRED]: 'Unpaired',
};

export const WAREHOUSE_ORDER_PAIRING_STATE_COLOR: Record<
  EWarehouseOrderPairingState,
  string
> = {
  [EWarehouseOrderPairingState.PAIRED]: 'green',
  [EWarehouseOrderPairingState.SUGGESTED]: 'orange',
  [EWarehouseOrderPairingState.UNPAIRED]: 'red',
};

export const WAREHOUSE_ORDER_PAIRING_SOURCE_LABEL: Record<
  EWarehouseOrderPairingSource,
  string
> = {
  [EWarehouseOrderPairingSource.NOTE]: 'Order code in note',
  [EWarehouseOrderPairingSource.PRODUCT_MATCH]: 'Product match',
  [EWarehouseOrderPairingSource.MANUAL]: 'Paired by staff',
};

export const WAREHOUSE_ORDER_EVENT_TYPE_LABEL: Record<
  EWarehouseOrderEventType,
  string
> = {
  [EWarehouseOrderEventType.CREATED]: 'Created',
  [EWarehouseOrderEventType.UPDATED]: 'Updated',
  [EWarehouseOrderEventType.PAIRED]: 'Paired',
  [EWarehouseOrderEventType.UNPAIRED]: 'Unpaired',
  [EWarehouseOrderEventType.SYNC_COMPLETED]: 'Sync completed',
  [EWarehouseOrderEventType.SYNC_FAILED]: 'Sync failed',
};

export const WAREHOUSE_ORDER_CHANGE_FIELD_LABEL: Record<
  EWarehouseOrderChangeField,
  string
> = {
  [EWarehouseOrderChangeField.STATUS]: 'Status',
  [EWarehouseOrderChangeField.NOTE]: 'Note',
  [EWarehouseOrderChangeField.TOTAL_WITHOUT_TAX]: 'Total without VAT',
  [EWarehouseOrderChangeField.FEES_WITHOUT_TAX]: 'Fees without VAT',
  [EWarehouseOrderChangeField.ITEMS]: 'Items (quantity/delivered)',
  [EWarehouseOrderChangeField.INVOICES]: 'Invoices',
};

export const ACTOR_TYPE_LABEL: Record<EOrderEventActorType, string> = {
  [EOrderEventActorType.STAFF]: 'Staff',
  [EOrderEventActorType.CUSTOMER]: 'Customer',
  [EOrderEventActorType.SYSTEM]: 'System',
};

export const formatAmount = (
  value: number | null,
  currencyIsoCode: string,
): string =>
  value === null ? EMPTY_VALUE : `${value.toFixed(2)} ${currencyIsoCode}`;

export const formatEur = (value: number | null): string =>
  formatAmount(value, WAREHOUSE_ORDER_REPORT_CURRENCY_ISO_CODE);

export const formatPercent = (value: number | null): string =>
  value === null ? EMPTY_VALUE : `${value.toFixed(1)} %`;
